import { createFileRoute } from "@tanstack/react-router";
import { PipettingScheme } from "../../app/views/pcr/pipettingScheme";

export const Route = createFileRoute("/pcr/pipette")({
  component: PipettingScheme,
});
